import { Component } from '@angular/core'

@Component({
  selector: 'flo-two-column-skeleton',
  templateUrl: './two-column-skeleton.component.html',
  styleUrls: ['./two-column-skeleton.component.scss']
})
export class TwoColumnSkeletonComponent {}
